import { Bot, Briefcase, CalendarDays, FileText, GitBranch, MessageCircle, Target, Users } from 'lucide-react';
import { useAppStore } from '../store.js';
import { t } from '../lib/i18n.js';

const recruiterNav = [
  ['today', 'today', CalendarDays],
  ['jobs', 'jobs', Briefcase],
  ['candidates', 'candidates', Users],
  ['pipeline', 'pipeline', GitBranch],
  ['chat', 'chat', MessageCircle],
  ['ai', 'ai', Bot]
];

const careerNav = [
  ['today', 'today', CalendarDays],
  ['jobs', 'jobs', Briefcase],
  ['pipeline', 'applications', GitBranch],
  ['cv', 'cv', FileText],
  ['chat', 'chat', MessageCircle],
  ['ai', 'ai', Bot]
];

export function ProductSwitch() {
  const productMode = useAppStore((s) => s.productMode);
  const setProductMode = useAppStore((s) => s.setProductMode);
  return (
    <nav className="product-switch" aria-label="Продуктовый режим">
      <button className={productMode === 'recruiter' ? 'active' : ''} onClick={() => setProductMode('recruiter')}>Hire OS</button>
      <button className={productMode === 'career' ? 'active' : ''} onClick={() => setProductMode('career')}><Target size={15} /> Career OS</button>
    </nav>
  );
}

export function LanguageSwitch() {
  const language = useAppStore((s) => s.language);
  const setLanguage = useAppStore((s) => s.setLanguage);
  return (
    <nav className="language-switch" aria-label="Language">
      <button className={language === 'ru' ? 'active' : ''} onClick={() => setLanguage('ru')}>RU</button>
      <button className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>EN</button>
    </nav>
  );
}

export function ModeSwitch() {
  const mode = useAppStore((s) => s.mode);
  const setMode = useAppStore((s) => s.setMode);
  return (
    <nav className="mode-switch" aria-label="Режим интерфейса">
      {['quick', 'advanced', 'pro'].map((item) => (
        <button key={item} className={mode === item ? 'active' : ''} onClick={() => setMode(item)}>{item[0].toUpperCase() + item.slice(1)}</button>
      ))}
    </nav>
  );
}

export function BottomNav() {
  const view = useAppStore((s) => s.view);
  const setView = useAppStore((s) => s.setView);
  const productMode = useAppStore((s) => s.productMode);
  const nav = productMode === 'career' ? careerNav : recruiterNav;
  const language = useAppStore((s) => s.language);
  return (
    <nav className="bottom-nav" aria-label="Главная навигация">
      {nav.map(([id, labelKey, Icon]) => (
        <button key={id} className={view === id ? 'active' : ''} onClick={() => setView(id)}>
          <Icon size={18} />
          <span>{t(language, labelKey)}</span>
        </button>
      ))}
    </nav>
  );
}
